import { addColumnBefore, addColumnAfter, deleteColumn, addRowBefore, addRowAfter, deleteRow, splitCell, mergeCells, toggleHeaderColumn, toggleHeaderRow, toggleHeaderCell, goToNextCell, deleteTable, } from 'prosemirror-tables';
export const tableOperations = {
    table: {
        delete: deleteTable,
    },
    column: {
        add_before: addColumnBefore,
        add_after: addColumnAfter,
        delete: deleteColumn,
    },
    row: {
        add_before: addRowBefore,
        add_after: addRowAfter,
        delete: deleteRow,
    },
    cell: {
        split: splitCell,
        merge: mergeCells,
        next: goToNextCell(1),
        prev: goToNextCell(-1),
    },
    header_column: {
        toggle: toggleHeaderColumn,
    },
    header_row: {
        toggle: toggleHeaderRow,
    },
    header_cell: {
        toggle: toggleHeaderCell,
    },
};
//# sourceMappingURL=operations.js.map